exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3{display: inline-block; margin:0;}\n.mat-select{margin-top: 15px;}\n.delete_icon i{font-size: 20px; color: #afafaf; margin-top: 20px;}\n.bottom_sec{padding: 30px 20px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/event-sponsorship/event-sponsorship.component.css
// module id = ../../../../../src/app/admin/event-sponsorship/event-sponsorship.component.css
// module chunks = 39